import { DashboardProvider } from "../../context/dashboard.contex"
import DateEnd from "./dateEnd/DateEnd"
import DateStart from "./dateStart/DateStart"
import css from './index.module.css'

function DashboardDatesGroup() {
  return (
      <div className={css.group}>
      <DateStart/>
      <DateEnd/>
    </div>
  )
}

export default DashboardDatesGroup